<template>
  <VList class="confirm-list-wrapper" ref="confirm-list">
    <VListItem class="list-item" v-for="(item, index) in list">
      <!-- <VRadioBox
        :name="name"
        class="radio-list-item"
        :value="item"
        :onChecked="() => { onClick(item); }"
        :state="state"
        :key="index"
        :width="width"
        :height="height"
      >
        <VSpan class="text" :text="item" :size="18" :color="TextColor.gray3" />
      </VRadioBox>-->
      <VBlock
        class="item-wrapper"
        :key="index"
        :onClick="() => { clickEvent(item) }"
        :ref="`confirm-list-item-${index}`"
      >
        <VSpan
          class="text"
          :text="item"
          :size="16"
          :color="state === item ? TextColor.brand : TextColor.darkGray"
          :weight="state === item ? TextWeight.bold : TextWeight.regular"
        />
        <VImage
          v-if="state === item"
          class="confirm-icon"
          :src="resources.ConfirmIcon"
          :width="24"
          :height="24"
        />
      </VBlock>
    </VListItem>
  </VList>
</template>

<script>
import VSpan, { TextColor, TextWeight } from '@/presentationals/v2/components/layouts/atoms/VSpan'
import VImage from '@/presentationals/v2/components/layouts/atoms/VImage'
// import VRadioBox from '@/presentationals/v2/components/layouts/atoms/VRadioBox'

import VList from '@/presentationals/v2/components/layouts/molecules/VList'
import VListItem from '@/presentationals/v2/components/layouts/molecules/VListItem'

import VBlock from '@/presentationals/v2/components/layouts/molecules/VBlock'

import ConfirmIcon from '@/assets/images/confirm-input-24.svg'

// import VSpan from '@/presentationals/v2/components/layouts/atoms/VSpan'

export default {
  name: 'RadioButtonList',
  props: {
    list: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    state: {
      type: String,
      required: true
    },
    onClick: {
      type: Function,
      required: true
    },
    width: {
      type: Number,
      default: 36
    },
    height: {
      type: Number,
      default: 36
    }
  },
  components: {
    // VRadioBox,
    // VSpan,
    VBlock,
    VList,
    VListItem,
    VSpan,
    VImage
  },
  methods: {
    clickEvent(item) {
      this.onClick(item)
    }
  },
  mounted() {
    const idx = this.list.findIndex(item => item === this.state)
    const name = `confirm-list-item-${idx}`
    this.$refs['confirm-list'].$el.scrollTo(
      0,
      idx * this.$refs[name][0].$el.getBoundingClientRect().height
    )
  },
  data() {
    return {
      TextColor,
      TextWeight,

      resources: {
        ConfirmIcon
      }
      // tempList: [
      //   '22:00 ~ 22:30',
      //   '11:30 ~ 12:00',
      //   '12:00 ~ 12:30',
      //   '12:30 ~ 13:00',
      //   '13:00 ~ 14:00',
      //   '14:00 ~ 15:00',
      //   '15:00 ~ 16:00',
      //   '16:00 ~ 17:00'
      // ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.confirm-list-wrapper {
  max-height: 300px;
  overflow-y: auto;
  box-sizing: border-box;
  // padding: 18px 15px 0 15px;
  padding: 0 15px 0 15px;

  .list-item {
    height: 24px;
    margin-bottom: 24px;

    // .radio-list-item {
    //   height: 24px;
    //   display: flex;
    //   align-items: center;

    //   .text {
    //     vertical-align: middle;
    //     padding-left: 6px;
    //   }
    // }

    .item-wrapper {
      width: 100%;
      height: 60px;
      box-sizing: border-box;
      padding: 0 15px 0 15px;
      position: relative;

      .text {
        width: 110px;
        text-align: center;
      }

      .confirm-icon {
        position: absolute;
        left: calc(50% + 67px);
        top: calc(50% - 3px);
        transform: translate(-50%, -50%);
        // margin-left: 8px;
        // padding-bottom: 6px;
      }

      // .active {
      //   color: $brand;
      // }
    }
  }
}
</style>